import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
`;

export const InfoSection = styled.div`
  background: ${props => props.theme.palette[200]};
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
`;

export const InfoRow = styled.div`
  display: flex;
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoLabel = styled.div`
  font-weight: 600;
  min-width: 200px;
  color: ${props => props.theme.palette[600]};
`;

export const InfoValue = styled.div`
  color: ${props => props.theme.palette[900]};
`;

export const CyclesSection = styled.div`
  background: ${props => props.theme.palette[200]};
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
`;

export const CycleCard = styled.div`
  background: ${props => props.theme.palette[100]};
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 10px;
`;